module.exports = __webpack_public_path__ + "img/15_BC16_grade_your_grubs.0e74e88d.jpg";